module.exports = __webpack_public_path__ + "img/x.77116870.svg";